import React from 'react';

const EnergiTerbarukanMikrogrid: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Tuntutan transisi menuju energi bersih mendorong berkembangnya riset sistem mikrogrid pintar skala mikro yang dapat diterapkan di fasilitas umum seperti sekolah, pos ronda, dan balai pertemuan warga. Namun, fluktuasi intensitas sinar matahari dan beban listrik yang tidak menentu sering kali membuat efisiensi pemanfaatan panel surya menjadi kurang optimal.
      </p>

      <p className="mb-4">
        Dalam ajang <b>Innovative Technology Challenge</b>, tim peserta menghadirkan prototipe <b>Smart Microgrid Management System</b> yang memanfaatkan mikrokontroler ESP32 dan algoritma <i>Maximum Power Point Tracking (MPPT)</i> cerdas untuk mendistribusikan daya listrik tenaga surya secara otomatis.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Fitur Unggulan Sistem Mikrogrid Pintar
      </h2>
      <ol className="list-decimal pl-6 mb-6 space-y-3">
        <li>
          <strong>Pengalihan Beban Otomatis (Smart Load Shedding):</strong> Memprioritaskan pasokan listrik ke perangkat vital (seperti penerangan darurat dan pompa air) saat daya simpan baterai berada di bawah ambang batas aman 30%.
        </li>
        <li>
          <strong>Monitoring Energi Real-Time:</strong> Mengukur parameter tegangan, arus masuk, dan konsumsi daya watt-jam (Wh) secara presisi menggunakan modul sensor INA219.
        </li>
        <li>
          <strong>Dashboard Pengawasan Nirkabel:</strong> Menampilkan grafik efisiensi daya harian dan estimasi pengurangan emisi karbon melalui antarmuka dashboard berbasis web lokal.
        </li>
      </ol>

      <div className="bg-emerald-50 border-l-4 border-emerald-500 p-4 mb-4 rounded-r-lg">
        <p className="text-gray-800 text-sm">
          <b>&quot;Efisiensi energi bukan hanya tentang memproduksi lebih banyak daya, melainkan tentang kecerdasan dalam mengelola setiap watt yang dihasilkan agar tidak terbuang percuma.&quot;</b>
        </p>
      </div>

      <p className="mb-4">
        Karya inovasi sistem mikrogrid mandiri ini membuktikan bahwa konsep energi baru dan terbarukan dapat diwujudkan dalam perangkat kompak yang siap pakai dan terjangkau untuk skala komunitas.
      </p>
    </div>
  );
};

export default EnergiTerbarukanMikrogrid;
